import React from 'react';
import PropTypes from 'prop-types';
import { FiShare } from 'react-icons/fi';

import styles from './styles.scss';

export class ShareIconButton extends React.Component {
    static propTypes = {
        showSocials: PropTypes.func,
        color: PropTypes.string,
        thing: PropTypes.string,
        hasShadow: PropTypes.bool,
    };

    static defaultProps = {
        color: '#000',
        hasShadow: false,
        thing: 'product',
    };

    render() {
        const { color, hasShadow, thing, showSocials } = this.props;

        return (
            <div className={styles.btn} data-modal-btn={`share${thing}`} onClick={showSocials}>
                <FiShare
                    size={24}
                    color={color}
                    style={{ filter: hasShadow ? 'drop-shadow(0 1px 3px rgba(0,0,0,0.3))' : null }}
                />
            </div>
        );
    }
}
